export const SAVE_DATA_NOTIONAL_POOLING = 'SAVE_DATA_NOTIONAL_POOLING'
export const NOTIONAL_POOLING_DELETEPOOL = 'NOTIONAL_POOLING_DELETEPOOL'
export const SET_CURRENT_NOTIONAL_POOLING_STATUSES = 'SET_CURRENT_NOTIONAL_POOLING_STATUSES'
export const SET_CURRENT_NOTIONAL_POOLING_PARTY_CURRENCY = 'SET_CURRENT_NOTIONAL_POOLING_PARTY_CURRENCY'
export const SET_CURRENT_NOTIONAL_POOLING_BD_ACCOUNTS = 'SET_CURRENT_NOTIONAL_POOLING_BD_ACCOUNTS'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON = 'SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_ACCODRIAN = 'SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_ACCODRIAN'
export const SET_CURRENT_NOTIONAL_POOLING_INTEREST_OPTIMIZATION_DATA = 'SET_CURRENT_NOTIONAL_POOLING_INTEREST_OPTIMIZATION_DATA'
export const SET_CURRENT_NOTIONAL_POOLING_INTEREST_PERIOD_SETTLEMENT_DATE = 'SET_CURRENT_NOTIONAL_POOLING_INTEREST_PERIOD_SETTLEMENT_DATE'
export const UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO'
export const SET_STATND_ALONE_ACCOUNTS = 'SET_STATND_ALONE_ACCOUNTS'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_1 ='SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_1'
export const SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_2 ='SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_2'
export const SET_CURRENT_NOTIONAL_POOLING_POOL_ID ='SET_CURRENT_NOTIONAL_POOLING_POOL_ID'
export const RESET_CURRENT_NOTIONAL_POOLING_POOL_ID='RESET_CURRENT_NOTIONAL_POOLING_POOL_ID'
export const SET_NEW_POOL_ACTIVE_TAB_INDEX = 'SET_NEW_POOL_ACTIVE_TAB_INDEX';
export const RESET_NEW_POOL_ACTIVE_TAB_INDEX = 'RESET_NEW_POOL_ACTIVE_TAB_INDEX';



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/actions/actionTypes.js